/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseVoid } from '../../models/api-response-void';

export interface PatchOrderPaymentStatus$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
  paymentStatus: 'PENDING' | 'PAID' | 'FAILED' | 'REFUNDED' | 'REVERSED' | 'CAPTURED' | 'PARTIAL_REVERSED' | 'PARTIAL_REFUNDED' | 'PARTIAL_CAPTURED' | 'REJECTED' | 'APPROVED' | 'EXPIRED';
}

export function patchOrderPaymentStatus(http: HttpClient, rootUrl: string, params: PatchOrderPaymentStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
  const rb = new RequestBuilder(rootUrl, patchOrderPaymentStatus.PATH, 'patch');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.query('paymentStatus', params.paymentStatus, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseVoid>;
    })
  );
}

patchOrderPaymentStatus.PATH = '/v1/api/orders/payment-status/{ref}';
